"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.updateFieldStateWithCallback = exports.subscribeToNamespace = exports.subscribeToField = exports.removeField = exports.getNamespaceState = exports.getFieldState = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _constants = require("./constants");

var stateCreator = function stateCreator() {
  var state = {};
  var subscribers = {};
  var idCounter = 0;
  /**
   * @param namespace
   * @param fieldName
   * @returns {Object}
   */

  var getFieldState = function getFieldState(namespace, fieldName) {
    var _state$namespace;

    return ((_state$namespace = state[namespace]) == null ? void 0 : _state$namespace[fieldName]) || _constants.FIELD_STATE_DEFAULT;
  };
  /**
   * @param namespace
   * @returns {Object}
   */


  var getNamespaceState = function getNamespaceState(namespace) {
    return state[namespace] || _constants.NAMESPACE_STATE_DEFAULT;
  };

  var subscribe = function subscribe(callback, namespace, fieldName) {
    if (!subscribers[namespace]) {
      subscribers[namespace] = new Map();
    }

    var id = ++idCounter;
    subscribers[namespace].set(id, {
      fieldName: fieldName,
      callback: callback
    });
    return function () {
      subscribers[namespace] && subscribers[namespace].has(id) && subscribers[namespace]["delete"](id);
    };
  };

  var subscribeToField = function subscribeToField(namespace, fieldName, callback) {
    return subscribe(callback, namespace, fieldName);
  };

  var subscribeToNamespace = function subscribeToNamespace(namespace, callback) {
    return subscribe(callback, namespace);
  };

  var triggerSubscribers = function triggerSubscribers(namespace, _fieldName) {
    var namespaceSubscribers = subscribers[namespace];

    if (namespaceSubscribers) {
      var fieldState = getFieldState(namespace, _fieldName);
      var namespaceState = getNamespaceState(namespace);
      namespaceSubscribers.forEach(function (_ref) {
        var callback = _ref.callback,
            fieldName = _ref.fieldName;

        if (!fieldName) {
          callback(namespaceState);
        } else if (fieldName === _fieldName) {
          callback(fieldState);
        }
      });
    }
  };

  var updateFieldStateWithCallback = function updateFieldStateWithCallback(namespace, fieldName, callback) {
    var currentFieldState = getFieldState(namespace, fieldName);
    var update = callback(currentFieldState);

    if (update) {
      var _extends2;

      state[namespace] = (0, _extends3["default"])({}, state[namespace], (_extends2 = {}, _extends2[fieldName] = (0, _extends3["default"])({}, currentFieldState, update), _extends2));
      triggerSubscribers(namespace, fieldName);
    }
  };

  var removeField = function removeField(namespace, fieldName) {
    var _state$namespace2;

    if ((_state$namespace2 = state[namespace]) != null && _state$namespace2[fieldName]) {
      delete state[namespace][fieldName];

      if (Object.keys(state[namespace]).length === 0) {
        delete state[namespace];
      }

      triggerSubscribers(namespace, fieldName);
    }
  };

  return {
    getFieldState: getFieldState,
    getNamespaceState: getNamespaceState,
    removeField: removeField,
    subscribeToField: subscribeToField,
    subscribeToNamespace: subscribeToNamespace,
    updateFieldStateWithCallback: updateFieldStateWithCallback
  };
};

var _stateCreator = stateCreator(),
    getFieldState = _stateCreator.getFieldState,
    getNamespaceState = _stateCreator.getNamespaceState,
    removeField = _stateCreator.removeField,
    subscribeToField = _stateCreator.subscribeToField,
    subscribeToNamespace = _stateCreator.subscribeToNamespace,
    updateFieldStateWithCallback = _stateCreator.updateFieldStateWithCallback;

exports.updateFieldStateWithCallback = updateFieldStateWithCallback;
exports.subscribeToNamespace = subscribeToNamespace;
exports.subscribeToField = subscribeToField;
exports.removeField = removeField;
exports.getNamespaceState = getNamespaceState;
exports.getFieldState = getFieldState;